import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { CouponsRes } from 'features/coupons/types/coupons.types'
import { useQuery } from 'libs/query'
import { useContext } from 'react'
import { useAxiosPrivate } from 'shared/hooks'
import { AuthContext } from 'store'
import { getCurrentQuery } from 'utils/getCurrentQuery'

export const useFetchCoupons = () => {
	const axiosPrivate = useAxiosPrivate()
	const { auth } = useContext(AuthContext)
	const query = getCurrentQuery()

	const {
		data: coupons,
		isPending: isCouponsLoading,
		isSuccess: isCouponsSuccess
	} = useQuery<CouponsRes>({
		queryKey: queryKeys.coupons.list(query),
		queryFn: () => axiosPrivate.get(apiRoutes.coupons(query)),
		enabled: !!auth.accessToken
	})

	return {
		coupons,
		isCouponsLoading,
		isCouponsSuccess
	}
}
